const applyConfig = (config) => {
  return config;
};

export default applyConfig;
